import React, { Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import qs from 'query-string'
import { Skeleton } from '@material-ui/lab'
import { Box, Button, Paper, Typography } from '@material-ui/core'

import useStyles from './styles'

const DashboardChartPaper = ({
  children,
  className,
  heightContainer,
  id,
  isLoading = false,
  noMaxHeight = false,
  redirect,
  redirectParams,
  subtitle,
  title,
  ...rest
}) => {
  const classes = useStyles(heightContainer)()
  const history = useHistory()

  const handleRedirect = () => {
    history.replace(redirect + '?' + qs.stringify(redirectParams))
  }

  return (
    <Paper
      className={clsx(
        classes.root,
        { [classes.paperContent]: noMaxHeight },
        className,
      )}
      {...rest}
    >
      <Box
        id={id}
        className={classes.columnBox}
        justifyContent={noMaxHeight ? 'start !important' : 'undefined'}
      >
        <Box className={classes.cardHeader}>
          <Typography variant="h5" className={classes.cardTitle}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        {isLoading ? (
          <Skeleton width="100%" height="100%" variant="rect" />
        ) : (
          <Fragment>
            <Box className={classes.cardContent}>{children}</Box>
            {!!redirect && (
              <Box p={1}>
                <Button variant="text" onClick={handleRedirect}>
                  Ver mais
                </Button>
              </Box>
            )}
          </Fragment>
        )}
      </Box>
    </Paper>
  )
}

DashboardChartPaper.propTypes = {
  className: PropTypes.string,
  heightContainer: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLoading: PropTypes.bool,
  noMaxHeight: PropTypes.bool,
  redirect: PropTypes.string,
  redirectParams: PropTypes.object,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default DashboardChartPaper
